import {DefaultInfoV1Props} from "@models/DefaultProps.ts";
import {ICcValorDistribuivel} from "@models/contaContabil/ICcValorDistribuivel.ts";
import {useState} from "react";
import {useCcDistribuibuivel} from "@components/contaContabil/valoresDistribuiveis/useCcDistribuibuivel.ts";
import {TableCell, TableRow, Typography} from "@mui/material";
import {ToDateDefault, ToDateTimeDefault, ToMoney} from "@shared/MathHelp.ts";
import {CheckOutlined, ClearOutlined} from "@mui/icons-material";

interface CcDistribuivelInfoProps extends Omit<DefaultInfoV1Props<ICcValorDistribuivel>, 'variant'> {

}

export function CcDistribuivelRow(props: CcDistribuivelInfoProps) {
    const {value, expectedId, EndComponent} = props
    const {getCcValorDistribuivelById} = useCcDistribuibuivel()

    const [v, setV] = useState<ICcValorDistribuivel | null>(value)
    if (v == null) {
        if (expectedId == null)
            return <>Valor indefinido...</>

        getCcValorDistribuivelById(expectedId).then(x => {
            setV(x)
        })
    }

    return (v != null && <TableRow>
        <TableCell>{v.id}</TableCell>
        <TableCell><Typography>{v.nome}</Typography></TableCell>
        <TableCell>{ToMoney(v.valor)}</TableCell>
        <TableCell>{v.status}</TableCell>
        <TableCell>{v.isAtivo ? <CheckOutlined color={'success'}/> : <ClearOutlined color={'error'}/>}</TableCell>
        <TableCell>{ToDateTimeDefault(v.dataCriacao)}</TableCell>
        <TableCell>{ToDateDefault(v.dataInicio)}</TableCell>
        <TableCell>{ToDateDefault(v.dataFim)}</TableCell>
        <TableCell align={'right'}>{EndComponent &&
            <EndComponent {...v}/>}</TableCell>

    </TableRow>)
}